import { useMemo } from 'react'
import { IntegrationServiceId } from '../../common/integrations'
import { useAppSelector } from '../../store/hooks'
import { selectContactChange, selectIsLoadingContactChange } from '../../store/meetingSummary/contactUpdate'
import { UpdateExternalContactForm } from './UpdateExternalContactForm'
import { UpToDate } from './ExternalContactUpdateIsUpToDate'
import { DataProcessingView } from './InitCreateOrUpdateExternalContact/DataProcessing/DataProcessingView'
import { ContactChange } from '../../models/MeetingSupport'
import { useContactUpdateHistory } from './ContactUpdateHistoryTypes'
import { getHistoryFilteredContactValues, getFilteredSchema } from './utils'

export interface DefaultExternalContactUpdateBodyProps {
  serviceId: IntegrationServiceId
  readonly?: boolean
  enableExplainer?: boolean
}

export const DefaultExternalContactUpdateBody: React.FC<DefaultExternalContactUpdateBodyProps> = ({ serviceId, readonly = false, enableExplainer = false }) => {
  const isLoadingContactChange = useAppSelector(selectIsLoadingContactChange)
  const contactChange = useAppSelector(selectContactChange)
  const historyContext = useContactUpdateHistory()

  const effectiveContactChange = useMemo(() => {
    if (historyContext?.isHistoryMode && historyContext.historyData && historyContext.historyData.serviceId === serviceId) {
      const filteredContactValues = getHistoryFilteredContactValues(historyContext.historyData.contactValues)
      const filteredSchema = getFilteredSchema(historyContext.historyData.contactSchema, filteredContactValues)

      return {
        contactValues: filteredContactValues,
        previousContactValues: {},
        contactSchema: filteredSchema,
        metadata: {},
      } as ContactChange
    }
    return contactChange
  }, [historyContext, contactChange, serviceId])

  const isMatchingHistoryMode = historyContext?.isHistoryMode && historyContext.historyData?.serviceId === serviceId
  if (!isMatchingHistoryMode && isLoadingContactChange) {
    return <DataProcessingView serviceId={serviceId} />
  }

  if (!isMatchingHistoryMode && !effectiveContactChange) {
    return <UpToDate serviceId={serviceId} />
  }

  const { contactSchema, previousContactValues } = effectiveContactChange || {}

  return (
    <UpdateExternalContactForm
      serviceId={serviceId}
      rootFieldId='contactValues'
      contactSchema={contactSchema || {}}
      contactValues={effectiveContactChange?.contactValues || {}}
      previousContactValues={previousContactValues || {}}
      requiredSteps={{}}
      metadata={{}}
      readonly={readonly}
      enableExplainer={enableExplainer}
    />
  )
}
